function getWorklistParsedName(name) {
	const nameParts = typeof name === 'string' ? name.split('^') : [];
	const lastName = nameParts[0] || '';
	const firstName = nameParts[1] || '';
	const middleName = nameParts[2] || '';

	return { firstName, middleName, lastName };
}
export default getWorklistParsedName;
